
import React, { Component } from 'react';
import { Button, Table } from 'reactstrap';
import Pagination from './Pagination';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Filter from './Filter';

export default class JobsList extends Component {
  // MS to be styled a bit better - not great on mobile.
  constructor(props) {
    super(props);

    this.state = {
      showFEFilters: this.props.extraFilters.raw && this.props.extraFilters.raw.selectedFilter ? true : false
    };
  }

  toggleFilters = () => {
    this.setState({ showFEFilters: !this.state.showFEFilters });
  }

  render() {

    const downIconStyle = {
      display: "inline-block",
      marginLeft: "0.255em",
      verticalAlign: "0.255em",
      borderTop: "0.3em solid",
      borderRight: "0.3em solid transparent",
      borderBottom: "0",
      borderLeft: "0.3em solid transparent"
    };

    if (!this.props.workOrders) {
      return null;
    }

    let rows = this.props.workOrders.map(workOrder => <Row key={workOrder.id} workOrder={workOrder} />);

    let showFEFilters = false;

    if (this.props.extraFilters.raw && this.props.extraFilters.raw.selectedOperator) {
      showFEFilters = true;
    } else if (this.state.showFEFilters) {
      showFEFilters = true;
    }

    return (
      <React.Fragment>
        <div style={{ display: 'flex' }} >
          <Button color="info" style={{ width: 200 }} onClick={this.toggleFilters}> Filter Jobs <span style={downIconStyle}></span></Button>
          {this.props.extraFilters.raw && this.props.extraFilters.raw.selectedFilter &&
            <Button color="danger" style={{ margin: "20px 0 20px 20px", width: 200 }} onClick={() => {
              this.props.resetFiltersAndData(this.props.woTypeAndOrder)
            }} > Remove filters </Button>}
        </div>
        {showFEFilters && 
        <Filter 
          fType={'jobs'} 
          extraFilters={this.props.extraFilters} 
          keepFilters={this.props.keepFilters} 
          woTypeAndOrder={this.props.woTypeAndOrder} 
          fetchWithFilters={this.props.getWorkOrders} 
          properties={this.props.properties}
        />}

        <Table responsive size="sm" style={{ marginTop: "12px" }}>
          <thead>
            <tr>
              <th>Booking</th>
              <th>Guest Type</th>
              <th>Required Date</th>
              <th>Property</th>
              <th>Description</th>
              <th></th>
            </tr>
          </thead>
          {rows}

        </Table>
        <div style={{ margin: "20px auto ", display: 'flex', justifyContent: "center" }}>
          <Pagination 
            stateStatus={this.props.dataStatus} 
            nextPage={this.props.getWorkOrders} 
            extraFilters={this.props.extraFilters} 
            typeAndOrder={this.props.woTypeAndOrder} 
          />
        </div>
      </React.Fragment>
    );
  }

}

class Row extends Component {

  markAsComplete = () => {
    // Update the state to reflect the fact that the component is updating
    this.setState({ updating: true });

    setTimeout(() => this.setState({ updating: false }), 1000);
  }

  render() {
    let workOrder = this.props.workOrder;
    let viewButton = <Link className='btn btn-primary btn-sm' to={`/job/${workOrder.id}`}>View</Link>

    return (
      <tbody>
        <tr>
          <td>{workOrder.booking ? workOrder.booking.id : ''}</td>
          <td>{workOrder.booking ? workOrder.booking.guesttype : ''}</td>
          <td>{moment(workOrder.preferredstartdatetime).format('ddd Do MMM YYYY')}</td>
          <td>{workOrder.property ? workOrder.property.name : ''}</td>
          <td>
            <div>{workOrder.fulldescription ? workOrder.fulldescription : workOrder.shortdescription}</div>
          </td>
          <td>
            {viewButton}
          </td>
        </tr>
      </tbody>
    );
  }
}


// WEBPACK FOOTER //
// ./src/JobsList.js